import { Component, OnInit } from '@angular/core';
import { ConfigService } from '../core/services/config.service';
import { SwapService } from '../core/services/swap.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-error-page',
    templateUrl: './error-page.component.html',
    styleUrls: ['./error-page.component.scss'],
    standalone: false
})
export class ErrorPageComponent implements OnInit {
  errorMessage: string;

  bgImage: string;
  bgFilterOpacity: number;

  constructor(
    private config: ConfigService,
    private swap: SwapService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.errorMessage = this.swap.getErrorMessage();

    this.bgImage = this.config.getConfigEx(
      'images:bgLogin',
      'assets/img/img-identity.jpg'
    );
    if (this.bgImage.indexOf('/') >= 0) {
      this.bgImage = `url(${this.bgImage})`;
    }
    this.bgFilterOpacity = this.config.getConfigEx(
      'images:bgLoginFilterOpacity',
      0.6
    );
  }

  onReturnToStart() {
    this.router.navigate(['/app']).then(() => window.location.reload());
  }
}
